import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowRight, Mouse } from 'lucide-react'
import useMouseParallax from 'hooks/useMouseParallax'
import doracLogo from 'assets/dorac-logo.svg'

function Banner() {
  const parallaxRef = useMouseParallax(30)

  return (
    <section
      id='home'
      ref={parallaxRef}
      className='relative flex min-h-screen items-center overflow-hidden pt-20'
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        className='pointer-events-none absolute inset-0 h-full w-full object-cover grayscale'
        style={{ opacity: 0.24 }}
      >
        <source src='/hero-video.mp4' type='video/mp4' />
      </video>
      <div className='pointer-events-none absolute inset-0 bg-white/65' />
      <div className='dorac-grid-bg pointer-events-none absolute inset-0' style={{ backgroundColor: 'transparent' }} />

      <div
        className='pointer-events-none absolute right-0 top-1/4 h-96 w-96 rounded-full bg-dorac-purple opacity-10 blur-3xl'
        style={{
          transform: 'translate3d(calc(var(--parallax-x, 0px) * 1.4), calc(var(--parallax-y, 0px) * 1.4), 0)',
        }}
      />
      <div
        className='pointer-events-none absolute bottom-1/4 left-0 h-64 w-64 rounded-full bg-dorac-purple opacity-10 blur-3xl'
        style={{
          transform: 'translate3d(calc(var(--parallax-x, 0px) * -1.2), calc(var(--parallax-y, 0px) * -1.2), 0)',
        }}
      />

      <div className='container relative z-10 mx-auto px-10 py-16 sm:px-4'>
        <div className='flex flex-col items-center gap-12 lg:flex-row lg:justify-between'>
          <div className='max-w-2xl text-left' style={{ perspective: '1000px' }}>
            <h1
              className='mb-6 max-w-2xl font-display text-4xl font-black tracking-tight text-dorac-ink transition-transform duration-150 ease-out sm:text-5xl lg:text-6xl'
              style={{
                lineHeight: 1.2,
                transform:
                  'translate3d(calc(var(--parallax-x, 0px) * 0.15), calc(var(--parallax-y, 0px) * 0.15), 0)',
              }}
            >
              Marketing Humanizado não é fofura, é{' '}
              <span
                style={{
                  background: 'linear-gradient(90deg, #491C47 0%, #8C4FB8 55%, #d99a3d 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                Ciência do{' '}Comportamento
              </span>{' '}
              e Consumo!
            </h1>

            <p
              className='mb-10 max-w-xl text-base text-dorac-ink/60 transition-transform duration-150 ease-out md:text-lg'
              style={{
                transform:
                  'translate3d(calc(var(--parallax-x, 0px) * 0.3), calc(var(--parallax-y, 0px) * 0.3), 0)',
              }}
            >
              Transformamos comportamento humano em posicionamento, narrativa e conversão. Sua marca mais desejada,
              mais confiável e mais escolhida.
            </p>

            <div
              className='flex flex-col items-start gap-4 transition-transform duration-150 ease-out sm:flex-row'
              style={{
                transform:
                  'translate3d(calc(var(--parallax-x, 0px) * 0.45), calc(var(--parallax-y, 0px) * 0.45), 0)',
              }}
            >
              <Link to='/contato' className='btn-dorac gap-2 px-8 py-4 text-base'>
                Solicitar diagnóstico gratuito
                <ArrowRight className='h-4 w-4' />
              </Link>
              <button
                type='button'
                onClick={() => document.getElementById('metodo')?.scrollIntoView({ behavior: 'smooth' })}
                className='btn-dorac-outline px-8 py-4 text-base'
              >
                Conhecer o Método DORAC
              </button>
            </div>
          </div>

          <div
            className='pointer-events-none hidden shrink-0 -translate-y-20 items-center justify-center lg:flex lg:flex-1 xl:-translate-y-10'
            style={{ perspective: '1200px' }}
          >
            <div className='animate-float'>
              <div
                role='img'
                aria-label=''
                className='h-[500px] w-[500px] bg-dorac-purple opacity-40 transition-transform duration-150 ease-out xl:h-[620px] xl:w-[620px]'
                style={{
                  WebkitMaskImage: `url(${doracLogo})`,
                  maskImage: `url(${doracLogo})`,
                  WebkitMaskRepeat: 'no-repeat',
                  maskRepeat: 'no-repeat',
                  WebkitMaskSize: 'contain',
                  maskSize: 'contain',
                  WebkitMaskPosition: 'center',
                  maskPosition: 'center',
                  transform:
                    'rotateY(calc(var(--parallax-x, 0px) / 1px * 0.5deg)) rotateX(calc(var(--parallax-y, 0px) / 1px * -0.5deg)) translate3d(calc(var(--parallax-x, 0px) * 0.7), calc(var(--parallax-y, 0px) * 0.7), 0)',
                }}
              />
            </div>
          </div>
        </div>

        <button
          type='button'
          onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
          className='group mx-auto mt-12 flex cursor-pointer flex-col items-center gap-2'
        >
          <span className='text-xs uppercase tracking-widest text-dorac-ink/40 transition-colors group-hover:text-dorac-purple'>
            Role para explorar
          </span>
          <Mouse className='h-5 w-5 animate-bounce text-dorac-purple/50 transition-colors group-hover:text-dorac-purple' />
        </button>
      </div>
    </section>
  )
}

export default Banner
